<template>
  <div class="mb-2 mb-sm-0">
    <div class="card-img-actions">
      <template v-if="attachment.type === 'image'">
        <a
          href="#"
          @click.prevent="toggler = !toggler"
        >
          <img
            class="img-fluid img-preview rounded"
            :src="attachment.url"
            :alt="attachment.filename"
            style="height: 5rem; display: inline-block;"
          >
        </a>
        <FsLightbox
          :toggler="toggler"
          type="image"
          :sources="[attachment.url]"
        />
      </template>
      <button
        v-else-if="attachment.type === 'video'"
        type="button"
        class="btn btn-link btn-float"
        :class="[isIncoming ? 'text-white' : 'text-dark']"
        @click.prevent="toggler = !toggler"
      >
        <img
          v-if="attachment.url_thumbnail"
          class="d-block mx-auto img-fluid img-preview rounded"
          :src="attachment.url_thumbnail"
          style="height: 5rem; display: inline-block;"
        >
        <img
          v-else
          src="@/static/play.svg"
          height="40"
          class="d-block mx-auto mb-2"
        >
        <span>{{ $t('room.play_video') }}</span>
        <FsLightbox
          :toggler="toggler"
          type="video"
          :sources="[attachment.url]"
          :show-thumbs-on-mount="true"
          :thumbs="[attachment.url_thumbnail]"
        />
      </button>
      <a
        v-else
        :href="attachment.url"
        class="btn btn-link btn-float"
        :class="[isIncoming ? 'text-white' : 'text-dark']"
      >
        <img
          src="@/static/document.svg"
          height="40"
          class="d-block mx-auto mb-2"
        >
        <div>{{ $t('room.download_file', {file_extension: fileExtension}) }}</div>
        <div class="text-truncate">{{ source.attachment.filename }}</div>
      </a>
    </div>
  </div>
</template>

<script>
import FsLightbox from "fslightbox-vue";
import {EmitterClient, TypeIncoming, TypeOutgoing} from "../../../../services/chat/const";

export default {
  name: 'AttachmentMessageRoomComponents',
  components: {
    FsLightbox,
  },
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      toggler: false,
    };
  },
  computed: {
    attachment() {
      return this.source.attachment;
    },
    type() {
      if (this.source.emitter === EmitterClient) {
        return TypeIncoming;
      } else {
        return TypeOutgoing;
      }
    },
    isIncoming() {
      return this.type === TypeIncoming;
    },
    fileExtension() {
      if (!this.source.attachment || !this.source.attachment.filename.length) {
        return '';
      }
      const f = this.source.attachment.filename.split('.');
      return f[f.length - 1].toUpperCase();
    },
  },
};
</script>

<style scoped>

</style>
